import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const Career = () => {  
  useEffect(() => {
    document.title = 'Career - St. Francis Xavier School';  
}, []);   

    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>   
                    <li>Career</li>
                </ul>
            </div> 
            <section className="innerbody">
                <div className="container"> 
                    <div className="row">  
                    <h6><b>Email</b> <Link to="mailto:sfxhsr@yahoo.com">: sfxhsr@yahoo.com </Link>  ,  <Link to="mailto:sfxhisarcampuscare@gmail.com"> sfxhisarcampuscare@gmail.com</Link> </h6> 
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mx-auto d-block"> 
                            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/career.png" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                        </div>  
                        
                     </div>  
              </div>  
           </section> 
           <Footer/>
        </>
    );
}

export default Career;
